import axios from 'axios';
import WebhookForm from './webhook-form.entity';
import WebhookListItem from './webhook-list-item.entity';
import WebhookType from './webhook-type.entity';

export default class WebhookService {
  public static getWebhookTypes(): Promise<WebhookType[]> {
    return axios.get('/api/v1/webhook-type')
      .then(({ data }) => data.map((it) => new WebhookType(it)));
  }

  public static postWebhook(businessUnitId: string, webhook: WebhookForm): Promise<any> {
    return axios.post(`/api/v1/business-units/${businessUnitId}/webhook`, webhook.formatToRequest());
  }

  public static putWebhook(businessUnitId: string, webhook: WebhookForm): Promise<any> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/webhook/${webhook.id}`, webhook.formatToRequest());
  }

  public static getWebhooks(businessUnitId: string): Promise<WebhookListItem[]> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/webhook`)
      .then(({ data }) => data.map((it) => new WebhookListItem(it)));
  }

  public static deleteWebhook(businessUnitId: string, webhookId: string): Promise<any> {
    return axios.delete(`/api/v1/business-units/${businessUnitId}/webhook/${webhookId}`);
  }
}
